<div class="modal-common" bg-close="false" uk-modal>
	<div class="uk-modal-dialog uk-padding-remove uk-margin-auto-vertical">
		<div class="uk-text-center +image-bg-modal">
			<img src="./assets/images/buy-modal.svg" width="300"/>
		</div>
		<div class="uk-border-rounded uk-background-default uk-padding">
			<!-- <h2 class="uk-modal-title uk-text-center uk-margin-small">
				{{ modalDisplay.title }}
			</h2> -->
			<div class="uk-modal-body uk-padding-small uk-margin-bottom per-line" [innerHTML]="modalDisplay().body" >				
			</div>
			<div class="uk-text-center">
				<button
					class="uk-button uk-button-primary uk-border-rounded"
					(click)="redirectCallBack()">
					ตกลง
				</button>
			</div>
		</div>
	</div>
</div>
